module.exports = __webpack_public_path__ + "static/img/JACOB-FARROW.d7e6102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACOB-FARROW.jpg
// module id = 4Bn9
// module chunks = 0